/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: any } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const roleRaw = currentUser?.role;
  const role = typeof roleRaw === 'string' ? roleRaw.toLowerCase().trim() : '';
  const supplierRaw = currentUser?.supplierCode ?? (currentUser as any)?.supplier_code;
  const supplierCode =
    typeof supplierRaw === 'string' ? supplierRaw.trim() : supplierRaw ?? '';
  // 企业（租户）管理账号：绑定了企业编码即为企业账号（企业归属优先于角色，
  // 与后端 guard 一致——企业认证只写 supplierCode 不改 role，role=admin 的企业账号
  // 不应被当成平台 admin；平台 admin 的 supplierCode 恒为空，不受影响）
  const isEnterprise = !!supplierCode;
  // 调试：打印当前用户角色与权限判断结果
  // eslint-disable-next-line no-console
  //console.log('access - currentUser:', currentUser);
  // eslint-disable-next-line no-console
  //console.log('access - currentUser.role:', role);
  // eslint-disable-next-line no-console
  //console.log('access - canAdmin (role === \"admin\"):', role === 'admin');
  return {
    // 兼容路由中的 access: 'canAdmin'（admin 与 observer 均可见 Admin 菜单）
    canAdmin: role === 'admin' || role === 'observer',
    isAdmin: role === 'admin',
    isObserver: role === 'observer',
    // canEditAdmin 为 true 时表示能在管理员界面进行写操作（admin），observer 会看到界面但不能编辑
    canEditAdmin: role === 'admin',
    canEditProviders: role === 'admin' || role === 'observer',
    // 企业管理相关
    isEnterprise,
    // 可见「企业管理」菜单：管理员、观察员或企业账号
    canTenant: role === 'admin' || role === 'observer' || isEnterprise,
    // 可编辑企业全部信息（含接入数量）：仅管理员
    canEditTenant: role === 'admin',
    // 企业账号可自行维护名称与 Logo
    canEditTenantProfile: role === 'admin' || isEnterprise,
    // 可维护设备授权与产线 Token：管理员或企业账号（观察员只读）
    canEditTenantLicense: role === 'admin' || isEnterprise,
    canEditProductionToken: role === 'admin' || isEnterprise,
    // 开放平台写操作（应用/密钥/日志）：管理员或已开通开发者
    canOpenAPI: role === 'admin' || !!currentUser?.openapiDeveloperEnabled,
    // GitHub 开发者认证
    isGitHubDeveloper: role === 'admin' || !!currentUser?.githubVerified,
    // 企业认证（绑定 Tenant）
    isEnterpriseCertified: role === 'admin' || !!currentUser?.enterpriseCertified || isEnterprise,
  };
}
